import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { VerifySignP7S } from "../../routes/cryptography";
import { Buffer } from "buffer"

//const feedback = "Ты сделал это!";

class VerifySign extends Component {
  constructor() {
    super();
    this.state = {
      dataSign: {
        data: "",
        fileSign: "",
        statusSign: "",
      },
      filename: "файл",
      signFileName: "файл",
      certFileName: "файл",
      sosFileName: "файл",
      p7bFileName: "файл",

      fileIsOpen: false,
      signFileIsOpen: false,
      certFileIsOpen: false,
      sosFileIsOpen: false,
      p7bFileIsOpen: false,

      isValidFileSize: true,
      isValidCertFileSize: true,
      isValidSignKeyFileSize: true,

      errors: {},
    };
    ///////VerifySign Func////
    this.handleInputChangeDataSign = this.handleInputChangeDataSign.bind(this);
    this.handleFileForSignChange = this.handleFileForSignChange.bind(this);
    this.handleSignChange = this.handleSignChange.bind(this);
    this.handleCertChange = this.handleCertChange.bind(this);
    this.handleSignSubmit = this.handleSignSubmit.bind(this);
  }

  componentDidMount() { }

  handleInputChangeDataSign(e) {
    //console.log(e.target.value);
    try {
      if (e.target.value.length === 0) {
        //console.log("ok");
        document.getElementById("dataForSign").disabled = false;
      } else {
        document.getElementById("dataForSign").disabled = true;

      }
      this.setState({
        filename: "файл",
        fileIsOpen: false,
        // signFileName: "файл",
        // signFileIsOpen: false,
        // certFileName: "файл",
        // certFileIsOpen: false,

        dataSign: {
          ...this.state.dataSign,
          data: btoa(unescape(encodeURIComponent(e.target.value))),
        },
      });
      //console.log(e.target.value.length);

      // //console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileForSignChange() {
    try {
      const file = document.getElementById("dataForSign").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        document.getElementById("inputDataSign").disabled = true;
        this.setState({
          filename: file.name, isValidFileSize: true,
          fileIsOpen: true
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");
          // const data1 = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            dataSign: { ...this.state.dataSign, data: data },
          });
          //console.log(data);
          //console.log(data1);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        document.getElementById("inputDataSign").disabled = false;

        this.setState({
          filename: "файл", isValidFileSize: false,
          fileIsOpen: false
        });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleSignChange() {
    try {
      const file = document.getElementById("fileSign").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ signFileName: file.name, isValidSignKeyFileSize: true, signFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataSign: { ...this.state.dataSign, fileSign: data },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ signFileName: "файл", isValidSignKeyFileSize: false, signFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleSignSubmit(e) {
    e.preventDefault();
    try {
      //console.log(`Данные: ${this.state.dataSign.data}`);
      //console.log(`P7S: ${this.state.dataSign.fileSign}`);
      //console.log(`cert: ${this.state.fileCert}`);

      VerifySignP7S(
        this.state.dataSign.fileSign,
        this.state.dataSign.data,
        this.state.fileCert
      ).then((result) => {
        try {
          //console.log(result);
          if (result.status === 200) {
            this.setState({
              dataSign: { ...this.state.dataSign, statusSign: result.data },
            });
          } else {
            this.setState({
              dataSign: {
                ...this.state.dataSign,
                statusSign: "Неуспешная проверка подписи!",
              },
            });
          }
        } catch (error) {
          //console.log(error);
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }
  handleCertChange() {
    try {
      const file = document.getElementById("fileCert").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {
        this.setState({ certFileName: file.name, isValidCertFileSize: true, certFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString();

          this.setState({
            fileCert: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ certFileName: "файл", isValidCertFileSize: false, certFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }
  render() {
    return (
      <div className="container">
        <h4 className="major">Проверка подписи</h4>
        <Form onSubmit={this.handleSignSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Введите текст</Form.Label>
              <Form.Control
                id="inputDataSign"
                onChange={this.handleInputChangeDataSign}
                type="text"
                placeholder="Текст"
                style={{ color: 'white' }}
              />
            </Form.Group>

            <Form.Label style={{ marginLeft: "50%" }}>или</Form.Label>

            <Form.Group
              style={{ paddingBottom: "20px", borderBottom: "1px solid white" }}
            >
              <Form.Label>Выберите файл </Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="dataForSign"
                  onChange={this.handleFileForSignChange}
                  isValid={this.state.fileIsOpen}
                  isInvalid={!this.state.isValidFileSize}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filename}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите файл P7S(Подпись)</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileSign"
                  onChange={this.handleSignChange}
                  isValid={this.state.signFileIsOpen}
                  isInvalid={!this.state.isValidSignKeyFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.signFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Выберите сертификат</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileCert"
                  onChange={this.handleCertChange}
                  isValid={this.state.certFileIsOpen}
                  isInvalid={!this.state.isValidCertFileSize}

                  required
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.certFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Label style={{ float: "left" }}>
              {this.state.dataSign.statusSign}
            </Form.Label>
            <Button
              style={{ float: "right" }}
              variant="success"
              type="submit"
              size="sm"
            >
              Проверить
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(VerifySign));
